<template>
  <el-dialog :visible.sync="show" width="480px" append-to-body :title="drawRow.info.title">
    <div class="content">
      <template v-if="drawRow.type === 'outTime'">
        {{ $t('operate-analysis::order-analysis::超过') }}
        <el-input-number
          v-model="form.outTimeDays"
          :min="0"
          @blur="defaultData('outTimeDays')"
          class="margin-input"
        ></el-input-number>

        {{ $t('operate-analysis::order-analysis::outTime_title') }}
      </template>
      <template v-else-if="drawRow.type === 'deliver'">
        {{ $t('operate-analysis::order-analysis::以') }}
        <el-input-number
          v-model="form.deliverIntervalDays"
          :min="0"
          @blur="defaultData('deliverIntervalDays')"
          class="margin-input"
        ></el-input-number>
        {{ $t('operate-analysis::order-analysis::time_title') }}
      </template>
      <template v-else-if="drawRow.type === 'perform'">
        {{ $t('operate-analysis::order-analysis::以') }}
        <el-select v-model="form.startSetDate" class="margin-input" style="margin:0 16px">
          <el-option
            :label="$t('operate-analysis::order-analysis::订单支付时间')"
            value="pay_to_received_day"
          ></el-option>
          <el-option
            :label="$t('operate-analysis::order-analysis::订单发货时间')"
            value="send_to_received_day"
          ></el-option>
        </el-select>
        {{ $t('operate-analysis::order-analysis::begin_title') }}
        <el-input-number
          v-model="form.performIntervalDays"
          :min="0"
          class="margin-input"
          style="margin:0 16px"
          @blur="defaultData('performIntervalDays')"
        ></el-input-number>
        {{ $t('operate-analysis::order-analysis::time_title') }}
      </template>
    </div>
    <div class="footer_class" slot="footer" style="text-align: center; display: block">
      <el-button @click="show = false">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button @click="save" type="primary" :loading="loading">{{ $t('system::common::btn::confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { postReportSetting } from '@/server/user'
export default {
  props: {
    value: {},
    drawRow: {
      type: Object,
      default: () => {}
    },
    form: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      show: false,
      loading: false
    }
  },
  watch: {
    value(val) {
      this.show = val
    },
    show(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    defaultData(type) {
      if (!this.form[type]) {
        this.form[type] = 0
      }
    },
    async save() {
      let config = JSON.stringify(this.form)
      const { data } = await postReportSetting({ type: 0, config: config, status: 1 })
      if (data.code === this.$code) {
        this.$emit('save', this.drawRow.type)
        this.show = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-dialog__body {
  display: flex;
  justify-content: center;
  padding: 24px 36px;
}
.margin-input {
  margin: 0 10px;
  width: 180px;
}
.content {
  line-height: 60px;
}
</style>
